module.exports = __webpack_public_path__ + "static/media/nav_humburger.76745847.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/nav_humburger.svg
// module id = 1351
// module chunks = 0